export const isUnauthorizedError = (error: any) =>
	error?.extensions?.statusCode === 403 || error.extensions?.data?.authorized === false;
